import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgArchiveLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M3 7H1V1H23V7H21M3 7V23H18C19.6569 23 21 21.6569 21 20V7M3 7H21M8 11H16"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

SvgArchiveLarge.displayName = 'SvgArchiveLarge';
const ArchiveLarge = withForgeIconProps(SvgArchiveLarge, {
  name: 'Archive',
  usage: 'Use as a workflow icon that indicates an item is no longer needed',
  related: 'N/A',
  isLabelRequired: true,
  isNeutralInteractive: false,
  size: 'large',
});
export default ArchiveLarge;
